import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import { ConfirmDialogHost } from '@cupia/ui/confirm-dialog'
import './styles/global.css'
import { LandingRoute } from './routes/landing'
import { HostRoute } from './routes/host'
import { ViewerRoute } from './routes/viewer'
import { AdminRoute } from './routes/admin'
import { FeedBenchRoute } from './routes/feed-bench'

const container = document.getElementById('root')
if (!container) throw new Error('#root 를 찾을 수 없습니다')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingRoute />} />
        <Route path="/host" element={<HostRoute />} />
        <Route path="/v/:room" element={<ViewerRoute />} />
        {/* §10.0 계정 관리 — 인가는 서버가 본다(화면은 안내만) */}
        <Route path="/admin" element={<AdminRoute />} />
        {/* 자막 피드 계측 하네스 — **개발 전용**(스크롤 앵커링 e2e).
            import.meta.env.DEV 는 프로덕션 빌드에서 정적 false 로 접히므로
            이 라우트도 FeedBenchRoute 도 번들에서 통째로 빠진다. */}
        {import.meta.env.DEV && (
          <Route path="/__bench/feed" element={<FeedBenchRoute />} />
        )}
        {/* 알 수 없는 경로는 랜딩으로 */}
        <Route path="*" element={<LandingRoute />} />
      </Routes>
      {/* confirm() 전역 호스트 — 방 종료·자막 삭제 확인에 쓰인다(§14) */}
      <ConfirmDialogHost />
    </BrowserRouter>
  </StrictMode>,
)
